import { HTTPClient } from '../utils/request'

export default {
  login: (payload) => HTTPClient.post('/Login', payload),
  loginInfo: (payload) => HTTPClient.get(`/Usuario`),
  recoveryPassword: (payload) => HTTPClient.get(`/RecoveryPassword/${payload.email}`),
  menu: (payload) => HTTPClient.get(`/Login`),
  update: (payload) => HTTPClient.put('/Usuario', payload)
}
